import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchApplicantList } from "./applicantListByJobAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchApplicantListAsync = createAsyncThunk(
  "fetchApplicantList/fetch",
  async (uuid, { rejectWithValue }) => {
    try {
      const data = await fetchApplicantList(uuid);

      const resp = data.response.data;
      // const resp = data.response;
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ApplicantListByJobSlice = createSlice({
  name: "ApplicantListByJob",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicantListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicantListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchApplicantListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
  },
});

export const selectApplicantListByJob = (state) => state.applicantListByJob.data;

export default ApplicantListByJobSlice.reducer;
